import type { ProblemDetails } from "./types";

class HttpError extends Error {
  problemDetails: ProblemDetails;

  constructor(problemDetails: ProblemDetails) {
    super(problemDetails.title ?? 'Unknown Error');
    this.problemDetails = problemDetails;
    // set the prototype explicitly to make 'instanceof HttpError' work
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}

export {
  HttpError
}
